<template>
  <div class="container">
    <div class="row">
      <div class="col-4">
        <n-popover trigger="hover">
          <template #trigger>
            <i @click="sendToMyEmail()" class="fa fa-envelope text-xs download-icon" aria-hidden="true"></i>
          </template>
          <span>Email</span>
        </n-popover>
      </div>
      <div class="col-4">
        <n-popover trigger="hover">
          <template #trigger>
            <i @click="viewFile()" class="fa fa-eye text-xs eye-icon" aria-hidden="true"></i>
          </template>
          <span>View</span>
        </n-popover>
      </div>
      <div class="col-4">
        <n-popover trigger="hover">
          <template #trigger>
            <i @click="downloadMyFile()" class="fa fa-download text-xs download-icon" aria-hidden="true"></i>
          </template>
          <span>Download</span>
        </n-popover>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { NPopover, useMessage } from "naive-ui";
import {sendFileToEmail, downloadFile, inProgress} from "../../composables/files/list";
import HttpClient from "project-blue-http-client";
import {FILES_URL, USER_LOG_URL} from "@/utils/constants";
import {getUserNotes} from "@/composables/notes/list";
import {userLogInputFields, saveToUserLogs, userEmail} from "@/composables/userLogs";

const showPopover = ref(false);
const message = useMessage();

const props = defineProps({
  selectedElement: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  url: {
    type: String,
    default: false,
  },
  id: {
    type: Number,
    default: null,
  },
  folderName: {
    type: String,
    default: null,
  },
});
const viewFile = async () => {
  var fileExtension = props.url.split('.').pop().split('?')[0].toLowerCase();
  if (fileExtension == ".xls" || fileExtension == ".xlsx") {
    window.open(`https://docs.google.com/viewer?embedded=true&url=${props.url}`);
    return;
  }
  userLogInputFields.value = {
    userEmail: localStorage.getItem('email'),
    description: `User ${localStorage.getItem('email')} viewed ${props.url}.`,
    action: "ViewFile",
    method: null,
    statusCode: 200,
    environment: window.location.hostname,
    endpoint: null,
    path: null
  }
  await saveToUserLogs(userLogInputFields.value)
  window.open(props.url);
};

const sendToMyEmail = async () => {
  await sendFileToEmail(props.id);
};

const downloadMyFile = async () => {
  await downloadFile(props.id, props.selectedElement.value, props.folderName.value)
};
</script>

<style lang="css" scoped>
.download-icon {
  color: #00213b;
  cursor: pointer;
}
</style>
